import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getLagerData as _getLagerData } from "@/api/largeData";
import store from "@/store/index";
export default {
  namespaced: true,
  state: {
    // 用户信息
    dataVList: {}
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} context
     * @param {*} info info
     *
     */
    getLagerData: function getLagerData(_ref) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var commit, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit;
                _context.next = 3;
                return _getLagerData();

              case 3:
                res = _context.sent;
                _context.next = 6;
                return commit("SET_data", res.data);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mutations: {
    SET_data: function SET_data(state, data) {
      state.dataVList = data;
      window.localStorage.setItem("dataVList", JSON.stringify(data));
    }
  }
};